import {
  Collection,
  CollectionFacet,
  CollectionInfo,
  CollectionsStore,
  KitchenCollection,
} from './collections-types';

/**
 * Возвращает данные об актуальных измерениях
 * @param {CollectionsStore} collections
 * @returns {Collection[]}
 */
export const selectAvailableCollections = (collections: CollectionsStore) => {
  const firstCollection = collections.collectionList?.[0];
  if (firstCollection && 'variants' in firstCollection) {
    const { collectionList } = collections;
    return (collectionList as Collection[])?.map((collection: Collection) => ({
      ...collection,
      variants: collection.variants.map(variant => ({
        ...variant,
        pointsOnAxis: variant.pointsOnAxis.filter(point => point.available),
      })),
    })) as Collection[];
  }

  return collections.collectionList || ([] as KitchenCollection[]);
};

/**
 * Возвращает фасет с ценами
 * @param {CollectionsStore} collections
 * @returns {CollectionFacet | undefined}
 */
export const selectPriceFacet = (collections: CollectionsStore): CollectionFacet | undefined =>
  collections.facets?.find(({ id }) => id === 'price');

/**
 * Возвращает фасет со стилями
 * @param {CollectionsStore} collections
 * @returns {CollectionFacet | undefined}
 */
export const selectStyleFacet = (collections: CollectionsStore): CollectionFacet | undefined =>
  collections.facets?.find(({ id }) => id === 'style');

/**
 * Возвращает признак доступности всех размеров коллекции
 * @param {CollectionsStore} collections
 * @returns {boolean}
 */
export const selectAreAllCollectionSizesUnavailable = (collections: CollectionsStore) => {
  if (!collections.collectionInfo) {
    return false;
  }

  return collections.collectionInfo.variants.variantsModel.every(variant =>
    variant.pointsOnAxis.every(point => !point.available)
  );
};

/**
 * Возвращает признак доступности коллекции
 * @param {CollectionsStore} collections
 * @returns {boolean}
 */
export const selectIsCollectionAvailable = (collections: CollectionsStore) =>
  Boolean(collections.collectionInfo?.variants.activePoint.available);

/**
 * Возвращает данные о коллекции
 * @param {CollectionsStore} collections
 * @returns {CollectionInfo}
 */
export const selectCollectionInfo = (collections: CollectionsStore) =>
  collections.collectionInfo || ({} as CollectionInfo);
